import { render, staticRenderFns } from "./AIBot.vue?vue&type=template&id=2942d56a&scoped=true"
import script from "./AIBot.vue?vue&type=script&lang=ts"
export * from "./AIBot.vue?vue&type=script&lang=ts"
import style0 from "./AIBot.vue?vue&type=style&index=0&id=2942d56a&prod&lang=scss&scoped=true"
import style1 from "./AIBot.vue?vue&type=style&index=1&id=2942d56a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2942d56a",
  null
  
)

export default component.exports